import React, { useEffect, useState } from 'react';

// Style
import './Header.scss';

// Link
import { createPortal } from 'react-dom';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Constants
import { categories } from 'constans/categories';

// Type
import { CategoriesType } from '../type';

// Hooks
import { Scrolling } from 'lib/hooks/scrolling';

// ClassNames
import clsx from 'clsx';

// Lib
import Cookies from 'js-cookie';
import { shallowEqual } from 'react-redux';
import { calcCountItems } from 'lib/helpers';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';

// Components
import Menu from '../Menu';
import Img from 'components/Img';
import BurgerMenu from '../Burger';
import Avatar from 'components/Avatar';
import AccountMenu from '../AccountMenu';
import Button from 'components/UiKit/Button';

// Actions
import { openModal } from 'reducers/modal';
import { getAddress } from 'pages/Checkout/reducer';
import { getCategories } from 'pages/Pfizer/reducer';
import { getAvatarUser } from 'pages/Account/reducer';
import { amplitudeInstance, events } from 'constans/cookie';
import * as actionsCreatorProjects from 'pages/Projects/reducer';
import { getAlllibraries, getCompoundsCount } from 'pages/Libraries/reducer';
import {
	toggleModal,
	getUsaStates,
	updateLogout,
	updateSettingsUser,
	getAddressesCountries
} from 'reducers/settings';
import { useRegisterTutorialKey } from 'lib/hooks/useTutorial';

export const Header: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const registerTutorialKey = useRegisterTutorialKey();
	const isSearchKeyboard = window.location.href.includes('text-search');

	let timeoutMenuId: ReturnType<typeof setTimeout>;
	let timeoutAccountId: ReturnType<typeof setTimeout>;

	const {
		user,
		avatar,
		isClose,
		projects,
		currentProject,

		loadingProjects,
		loadingCategories,

		categoriesMenu
	} = useAppSelector(
		(store) => {
			return {
				user: store.settings.user,
				isClose: store.settings.isCloseSmallDropdown,

				avatar: store.account.avatar,

				currentProject: store.projects.currentProject,
				projects: store.projects.dataProjects,
				loadingProjects: store.projects.loading,

				loadingCategories: store.pfizer.loading,
				categoriesMenu: store.pfizer.categoriesMenu
			};
		},
		shallowEqual
	);

	const countItems = calcCountItems(projects, (+currentProject || 0));

	const [currentTemplate, setCurrentTemplate] = useState<string>('');
	const [isMenuDropDownOpenAccount, setMenuDropDownOpenAccount] = useState<boolean>(false);
	const [isMenuDropDownOpenProducts, setMenuDropDownOpenProducts] = useState<boolean>(false);
	const [isMenuDropDownOpenLibraries, setMenuDropDownOpenLibraries] = useState<boolean>(false);

	useEffect(() => {
		type TimeoutId = ReturnType<typeof setTimeout>;
		let timeoutId: TimeoutId;

		timeoutId = setTimeout(() => {
			const isAuthorized = user.authorized;
			const key = isAuthorized
				? 'header-authorized'
				: 'header-unauthorized';

			const allLoaded = !loadingProjects && !loadingCategories;
			if (!allLoaded) return;

			const condition = !!categoriesMenu?.length && (isAuthorized ? !!projects?.length : true);
			if (!condition) return;

			registerTutorialKey(key, () => condition, 'normal', 'header');
		}, 1000);

		return () => {
			clearTimeout(timeoutId);
		};
	}, [
		user.authorized,
		projects,
		categoriesMenu,
		loadingProjects,
		loadingCategories,
		registerTutorialKey
	]);

	useEffect(() => {
		dispatch(getAlllibraries());
		dispatch(getCompoundsCount());

		dispatch(getCategories());
		dispatch(getUsaStates());
		dispatch(getAddressesCountries());
	}, []);

	const isScrolling = Scrolling({ limit: 20 });

	useEffect(() => {
		if (user.authorized) {
			dispatch(getAddress());
			dispatch(getAvatarUser());
			dispatch(actionsCreatorProjects.getListProjects());
		}
	}, [user]);

	useEffect(() => {
		window.addEventListener(
			'storage',
			handlerSynchronizationTabListener
		);

		return () => {
			clearTimeout(timeoutMenuId);
			clearTimeout(timeoutAccountId);

			dispatch(toggleModal(false));

			setCurrentTemplate('');
			setMenuDropDownOpenLibraries(false);
			setMenuDropDownOpenAccount(false);
			setMenuDropDownOpenProducts(false);
			window.removeEventListener(
				'storage',
				handlerSynchronizationTabListener
			);
		};
	}, []);

	useEffect(() => {
		return () => {
			clearTimeout(timeoutMenuId);
			clearTimeout(timeoutAccountId);

			setCurrentTemplate('');
			dispatch(toggleModal(false));
			setMenuDropDownOpenLibraries(false);
			setMenuDropDownOpenAccount(false);
			setMenuDropDownOpenProducts(false);
		};
	}, [location]);

	const handlerSynchronizationTabListener = (event: any) => {
		const parsedData = event.key === 'synchronizationTab'
			? JSON.parse(event.newValue)
			: { type: '' };

		const data = parsedData?.data;
		const type = parsedData?.type || '';

		if (type === 'SIGN_OUT') {
			dispatch(updateLogout());
		}

		if (type === 'UPDATE_SIGN_IN') {
			dispatch(updateSettingsUser(data));
		}

		if (type === 'UPDATE_CURRENT_PROJECT') {
			dispatch(actionsCreatorProjects.handlerChangeCurrentProject(data));
		}
	};

	const handlerClickSearch = () => {
		if (isSearchKeyboard) {
			navigate(-1);
			return;
		}

		navigate('/search?tab=text-search');
	};

	const handlerClickRedirect = (url: string) => () => {
		dispatch(openModal({
			type: 'redirect',
			url: url
		}));

		const isCookie = Cookies.get('cookieName');

		if (isCookie) {
			if (url === '/services') {
				amplitudeInstance.logEvent(events.services);
			}

			if (url === '/search?tab=bio-search') {
				amplitudeInstance.logEvent(events.search);
			}

			if (window.location.pathname === '/') {
				amplitudeInstance.logEvent(events.home_click);
			}
		}
	};

	const handlerToggleMenu = () => {
		dispatch(toggleModal(!isClose));
	};

	const onMouseEnter = () => {
		timeoutAccountId = setTimeout(() => {
			setMenuDropDownOpenAccount(true);
		}, 800);
	};

	const onMouseLeave = () => {
		setMenuDropDownOpenAccount(false);
		clearTimeout(timeoutAccountId);
	};

	const onMouseEnterItem = (isFirst: boolean, isSecond: boolean, template: string) => () => {
		timeoutMenuId = setTimeout(() => {
			setMenuDropDownOpenLibraries(isFirst);
			setMenuDropDownOpenProducts(isSecond);
			setCurrentTemplate(template);
		}, 800);
	};

	const onMouseLeaveItem = () => {
		setMenuDropDownOpenLibraries(false);
		setMenuDropDownOpenProducts(false);
		setCurrentTemplate('');
		clearTimeout(timeoutMenuId);
	};

	const cnAuthWrapper = clsx(
		'main-wrapper-avatar ml30',
		isMenuDropDownOpenAccount ? 'show-account' : ''
	);

	const cnMainWrapper = clsx(
		'wrapper-header',
		isScrolling ? 'wrapper-header__bg' : ''
	);

	const cnHeaderWrapper = clsx(
		'header header__avatar',
		isClose ? 'header__avatar--active-login' : '',
		isMenuDropDownOpenProducts ? 'header--is-active' : '',
		isMenuDropDownOpenLibraries ? 'header--is-active' : ''
	);

	const cnLogo = clsx(
		'logo',
		isScrolling ? 'logo--active' : ''
	);

	const mountElement = document.getElementById('wrapper-menu');
	const mountElementProducts = document.getElementById('wrapper-menu-products');

	const iconSearch = isSearchKeyboard ? 'crossSvg' : 'searchSvg';
	const headers = categories.filter(x => x.isHeader);

	return (
		<div className={cnMainWrapper}>
			<header className={cnHeaderWrapper}>
				<div className="header__top flex flex-ai-center flex-jc-between">
					<div className="flex flex-ai-center">
						<div className="flex flex-ai-center">
							<Link
								to="/"
								className="header__link"
								onMouseOver={() => {
									setMenuDropDownOpenLibraries(false);
									setMenuDropDownOpenProducts(false);
								}}
							>
								<Img
									isSvg
									alt="Logo"
									name="logoMain"
									className={cnLogo}
								/>
							</Link>
							<nav>
								<ul className="header__ul flex flex-ai-center">
									<div id="header-unauthorized-libraries-products" className="header__wrapper-li flex">
										{headers.slice(0, 4).map((x: CategoriesType, i: number) => {
											const isFirst: boolean = 0 === i;
											const isSecond: boolean = 1 === i;

											let templateColumn = '';
											if (isFirst) templateColumn = 'libraries';
											if (isSecond) templateColumn = 'products';

											return (
												<li
													key={x.id}
													className="header__li"
													id={isFirst ? 'header-id' : ''}
													onMouseLeave={onMouseLeaveItem}
													onMouseEnter={onMouseEnterItem(isFirst, isSecond, templateColumn)}
												>
													{x.isRedirect ?
														<span
															className="header__a"
															onClick={handlerClickRedirect(x?.link || '')}
														>
															{x.title || ''}
														</span>
														: x?.isLink ? (
															<Link to={x.link || ''} className="header__a">
																{x.title || ''}
															</Link>
														) : (
															<span className="header__a">{x.title || ''}</span>
														)}

													{isFirst && !isMenuDropDownOpenProducts &&
														<div className="wrapper-menu" id={isFirst ? 'wrapper-menu' : ''} />}
													{isFirst && mountElement && isMenuDropDownOpenLibraries && createPortal(
														<Menu template={currentTemplate} />,
														mountElement
													)}

													{isSecond && !isMenuDropDownOpenLibraries &&
														<div className="wrapper-menu" id={isSecond ? 'wrapper-menu-products' : ''} />}
													{isSecond && mountElementProducts && isMenuDropDownOpenProducts &&
														createPortal(
															<Menu template={currentTemplate} categoriesMenu={categoriesMenu} />,
															mountElementProducts
														)}
												</li>
											);
										})}
									</div>

									<li id="header-unauthorized-services" className="header__li">
										<Link to="/services" className="header__a">Services</Link>
									</li>

									<li id="header-unauthorized-search-li" className="header__li">
										<Link to="/search?tab=text-search" className="header__a">Search</Link>
									</li>

								</ul>
							</nav>
						</div>

						<BurgerMenu isScrolling={isScrolling} />
					</div>

					<div className="flex flex-ai-center relative">
						<Button
							isSvg
							color="info"
							variable="icon"
							icon={iconSearch}
							onPress={handlerClickSearch}
							className="header__btn-search"
							id="header-unauthorized-search"
						/>

						{user.authorized ?
							<div className="flex flex-ai-center">
								<Link
									to="/projects"
									id="header-authorized-basket"
									className="header__pallet relative"
								>
									<Img
										isSvg
										name="palletSvg"
										title="Go to My projects"
										className="header__pallet-svg"
									/>
									<div
										title={countItems}
										className="header__pallet-count flex flex-ai-center flex-jc-center"
									>
										<p>{countItems > 99 ? '99+' : countItems}</p>
									</div>
								</Link>
								<div
									className={cnAuthWrapper}
									onMouseEnter={onMouseEnter}
									onMouseLeave={onMouseLeave}
									id="header-authorized-avatar"
								>
									<Avatar
										isShowName
										avatar={avatar}
										title={user?.title || ''}
										name={
											user?.firstName &&
											(`${user?.firstName[0]}.` || '')
										}
										lastName={user?.lastName || ''}
									/>
									<AccountMenu />
								</div>
							</div>
							:
							<div
								id="header-unauthorized-avatar"
								className="main-wrapper-avatar ml30"
							>
								<Avatar
									isClose={isClose}
									title={user?.title || ''}
									onClick={handlerToggleMenu}
									name={user?.firstName || ''}
								/>
								<AccountMenu />
							</div>
						}
					</div>
				</div>
			</header>
		</div>
	);
};

export default Header;